// extracted by mini-css-extract-plugin
export default {"grid-alike-section":"BoxSection_grid-alike-section__gAZiz","grid-header-right":"BoxSection_grid-header-right__ZCU6+"};